import { useCallback } from "react";
import { createGalleryRequest, deleteGalleryRequest } from "../network";

export const useSetGallery = () => {
  const setGallery = useCallback(async (values: any) => {
    //@ts-ignore
    // if (!values["image"] instanceof FileList) {
    //   return;
    // }
    const fd = new FormData();
    fd.append("vehicle_id", values["vehicle_id"]);
    if (values["image"]) {
      for (let i = 0; i < values["image"].length; i++) {
        fd.append("image", values["image"][i]);
        await createGalleryRequest(fd);
        fd.delete("image");
      }
    }
  }, []);

  const deleteImage = useCallback(async (id) => {
    const res = await deleteGalleryRequest(id);
    return res;
  }, []);

  return { setGallery, deleteImage };
};
